module.exports = __webpack_public_path__ + "static/media/icon_otsu.c551c051.svg";